import { useQuery } from '@tanstack/react-query'
import { fetchRoles } from '@/features/users/api'

export function useRolesQuery() {
  return useQuery({
    queryKey: ['roles'],
    queryFn: fetchRoles
  })
}
